module.exports = __webpack_public_path__ + "static/media/philps.852b528c.jpg";